// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1tHCk","header":"ReportDetails_header__eq34T","title":"ReportDetails_title__2Jak8","left":"ReportDetails_left__282jb"};